import { createApp } from "vue";
import SpnRpnCompatibilityStatus from "./components/SpnRpnCompatibilityStatus.vue";
import { getMountElements, readPayload, VUE_MOUNTED_ATTRIBUTE } from "./utils/vueMount";

const MOUNT_SELECTOR = "[data-vue-spn-rpn-compatibility-status]";

export function initSpnRpnCompatibilityStatusApp(root = document) {
  const apps = [];

  for (const element of getMountElements(root, MOUNT_SELECTOR)) {
    if (element.hasAttribute(VUE_MOUNTED_ATTRIBUTE)) {
      continue;
    }

    const payload = readPayload(element);
    const app = createApp(SpnRpnCompatibilityStatus, {
      apiUrl: payload.apiUrl || "",
      batchApiUrl: payload.batchApiUrl || "",
      spnId: Number.parseInt(String(payload.spnId || "0"), 10) || 0,
      initialValue: payload.initialValue || "",
    });

    app.mount(element);
    element.setAttribute(VUE_MOUNTED_ATTRIBUTE, "1");
    apps.push(app);
  }

  return apps;
}